export enum StudentShortcutType {
  LESSONS = 'LESSONS',
  SCHEDULE = 'SCHEDULE',
  EXAMS = 'EXAMS',
  PROJECTS = 'PROJECTS',
  PERFORMANCE = 'PERFORMANCE',
}

const VISIBLE_SHORTCUTS: Record<StudentShortcutType, boolean> = {
  [StudentShortcutType.LESSONS]: true,
  [StudentShortcutType.SCHEDULE]: false,
  [StudentShortcutType.EXAMS]: false,
  [StudentShortcutType.PROJECTS]: true,
  [StudentShortcutType.PERFORMANCE]: false,
};

export function isStudentShortcutVisible(type: StudentShortcutType) {
  return VISIBLE_SHORTCUTS[type];
}
